import React from 'react'
import { Button, Form, Input, Select, Radio } from 'antd'

// mobx
import { useStore } from '@/store'
import { set, runInAction, toJS } from 'mobx'
import { observer } from 'mobx-react-lite'
// mobx
import { validatLength, validatLength2 } from '@/utils/check'

const DeviceInput = ({ title }) => {
  const { DeviceStore } = useStore()
  //获得table数据
  // 取消按钮
  const [form] = Form.useForm()

  //表单提交
  const onFinish = async (values) => {
    if (title === '添加') {
      await DeviceStore.getAddButtom(values)
    } else if (title === '编辑') {
      await DeviceStore.getPutInformation(values)
    }
    runInAction(() => {
      set(DeviceStore, { isActive: false })
    })
    form.resetFields()
  };

  return (
    <>
      {
        title === '添加' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={{
            sbzt: 1
          }}
        >
          <Form.Item label="所属系统" name='jrxtid'
            rules={[
              {
                required: true,
                message: '所属系统',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(DeviceStore.selectList)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属企业" name='qyxxid'
            rules={[
              {
                required: true,
                message: '所属企业',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(DeviceStore.selectList2)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属单元" name="dyglid" rules={[
            {
              required: true,
              message: '所属单元',
            }
          ]}>
            <Select placeholder="请选择" options={toJS(DeviceStore.selectList3)}>
            </Select>
          </Form.Item>
          <Form.Item label="工作状态" name="sbzt" rules={[
            {
              required: true,
              message: '请选择系统状态',
            }
          ]}>
            <Radio.Group>
              <Radio value={1}>启用</Radio>
              <Radio value={2}>禁用</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="设备编号" name="sbbh" rules={[
            {
              required: true,
              message: '请输入设备编号',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入设备编号" />
          </Form.Item>
          <Form.Item label="设备名称" name="sbmc" rules={[
            {
              required: true,
              message: '请输入设备名称',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入设备名称" />
          </Form.Item>
          <Form.Item label="设备型号" name="sbxh" rules={[
            {
              required: true,
              message: '请输入设备型号',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入设备型号" />
          </Form.Item>
          <Form.Item label="生产企业" name="scqy" rules={[
            {
              required: true,
              message: '请输入生产企业',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入生产企业" />
          </Form.Item>
          <Form.Item label="备注信息" name="bz" rules={[
            {
              required: true,
              message: '请输入备注信息',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              立即添加
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '编辑' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={toJS(DeviceStore.valueData)}
        >
          <Form.Item label="所属系统" name='jrxtid'
            rules={[
              {
                required: true,
                message: '所属系统',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(DeviceStore.selectList)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属企业" name='qyxxid'
            rules={[
              {
                required: true,
                message: '所属企业',
              }
            ]}>
            <Select placeholder="请选择" options={toJS(DeviceStore.selectList2)}>
            </Select>
          </Form.Item>
          <Form.Item label="所属单元" name="dyglid" rules={[
            {
              required: true,
              message: '所属单元',
            }
          ]}>
            <Select placeholder="请选择" options={toJS(DeviceStore.selectList3)}>
            </Select>
          </Form.Item>
          <Form.Item label="工作状态" name="sbzt" rules={[
            {
              required: true,
              message: '请选择系统状态',
            }
          ]}>
            <Radio.Group>
              <Radio value={1}>启用</Radio>
              <Radio value={2}>禁用</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="设备编号" name="sbbh" rules={[
            {
              required: true,
              message: '请输入设备编号',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入设备编号" readOnly={'readonly'} />
          </Form.Item>
          <Form.Item label="设备名称" name="sbmc" rules={[
            {
              required: true,
              message: '请输入设备名称',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入设备名称" />
          </Form.Item>
          <Form.Item label="设备型号" name="sbxh" rules={[
            {
              required: true,
              message: '请输入设备型号',
            },
            {
              validator: validatLength
            }
          ]}>
            <Input placeholder="请输入设备型号" />
          </Form.Item>
          <Form.Item label="生产企业" name="scqy" rules={[
            {
              required: true,
              message: '请输入生产企业',
            },
            {
              validator: validatLength2
            }
          ]}>
            <Input placeholder="请输入生产企业" />
          </Form.Item>
          <Form.Item label="备注信息" name="bz" rules={[
            {
              required: true,
              message: '请输入备注信息',
            }
          ]}>
            <Input.TextArea showCount maxLength={100} style={{ height: 120, resize: 'none', }} placeholder="请输入信息" />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Button type="primary" htmlType="submit">
              修改内容
            </Button>
          </Form.Item>
        </Form>
      }
      {
        title === '查看' && <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          form={form}
          onFinish={onFinish}
          initialValues={toJS(DeviceStore.valueData)}
        >
          <Form.Item label="所属系统" >
            {DeviceStore.valueData.xtmc}
          </Form.Item>
          <Form.Item label="所属企业" >
            {DeviceStore.valueData.qymc}
          </Form.Item>
          <Form.Item label="所属单元" >
            {DeviceStore.valueData.dymc}
          </Form.Item>
          <Form.Item label="工作状态" >
            {DeviceStore.valueData.sbzt === 1 ? '启用' : '禁用'}
          </Form.Item>
          <Form.Item label="设备编号" >
            {DeviceStore.valueData.sbbh}
          </Form.Item>
          <Form.Item label="设备名称" >
            {DeviceStore.valueData.sbmc}
          </Form.Item>
          <Form.Item label="设备型号" >
            {DeviceStore.valueData.sbxh}
          </Form.Item>
          <Form.Item label="生产企业" >
            {DeviceStore.valueData.scqy}
          </Form.Item>
          <Form.Item label="备注信息" >
            {DeviceStore.valueData.bz}
          </Form.Item>
        </Form>
      }
    </>
  )
}

export default observer(DeviceInput)